<template>
  <div class='module'>
    <h2 :class='{"module-title" : true, "open" : panelOpenState, "disabled" : disable}' @click='toggle'>
      <slot name='title'>{{ title }}</slot>
      <span class='indicator'/>
    </h2>
    <transition name='list'>
      <div v-show='panelOpenState' class='module-content'>
        <slot />
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'Module',

  inject: ['$validator'],

  props: {
    title: String,
    open: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      mutableOpen: this.open
    }
  },

  computed: {
    panelOpenState () {
      return this.mutableOpen && !this.disable
    }
  },

  methods: {
    toggle () {
      if (!this.disable) {
        this.mutableOpen = !this.mutableOpen
      }
    }
  }
}
</script>
